export async function fakeLatency(maxTimeMillis: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, Math.random() * maxTimeMillis);
  });
}
